/**
 * The tour runs outside React, so each host registers the handful of things it
 * alone can do. A phase whose host is not mounted simply skips that behaviour.
 */
export type FocPlanningTourApi = {
  expandFixturePlan: () => void;
  openApplyPlan: () => void;
  /** Unhide the org-chart Templates panel so Load can be highlighted. */
  ensureRosterSidebar: () => void;
  /** Opens the Load confirmation for the hurricane template. Does not apply it. */
  previewRosterLoad: () => void;
  navigateTo: (href: string) => void;
  resolveTasksHref: () => string | null;
  resolveRosterHref: () => string | null;
};

let api: Partial<FocPlanningTourApi> = {};

export function registerFocPlanningTourApi(
  partial: Partial<FocPlanningTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof FocPlanningTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getFocPlanningTourApi(): Partial<FocPlanningTourApi> {
  return api;
}
